import { Component, Input } from '@angular/core';

import { AiSupportMessageModel } from './typings/ai-support.message';

@Component({
  selector   : 'wor-ai-support-message',
  styles: [ require('./ai-support.message.component.scss') ],
  template: require('./ai-support.message.component.html')
})
export class AiSupportMessageComponent {
  @Input() message : AiSupportMessageModel;

  trackBySegment ( index : number ) : number {
    return index;
  }
}
